<template>
  <div class="file-uploader">
    <input ref="fileInput" v-if="!disabled && fileList.length===0" type="file" @change.stop="onFileChange" multiple/>
    <div  class="image-preview" v-if="!disabled && fileList.length===0">
      <img  :src="addIFile" alt="Preview"/>
      <div class="uploadTip" >{{$t('lang.workOrderReview.clickUpload')}}</div>
    </div>
    <div class="file-list" v-if="fileList.length!==0">
      <div class="fileInfo">
        <input  ref="fileInput"  type="file" @change.stop="onFileChange" multiple/>
        <img @click="removeFile()" class="closeBtn" src="../../assets/images/workOrderReview/close.png" alt="">
        <img src="../../assets/images/workOrderReview/addedFile.png" alt="">
        <div class="fileName">{{ fileList[0].name }}</div>
      </div>

  </div>
    <div class="file-list" v-if="defaultFile && fileList.length===0 && disabled">
      <div class="fileInfo">
        <img src="../../assets/images/workOrderReview/addedFile.png" alt="">
        <!--          <div class="fileName">{{ fileList[0].name }}</div>-->
        <div class="fileName">{{BankStatementName}}</div>
      </div>
      <div class="mask" v-if="defaultFile && fileList.length===0 && disabled">
        <div class="viewDetails" @click="goFile()">{{$t('lang.UploadProof.viewDetails')}}</div>
      </div>

      <!--      <ul>-->
      <!--        <li v-for="(file, index) in fileList" :key="index">-->
      <!--          {{ file.name }} ({{ formatFileSize(file.size) }})-->
      <!--        </li>-->
      <!--      </ul>-->
    </div>
    <div class="mask" v-if="!defaultFile && fileList.length===0 && disabled">
      {{$t('lang.UploadProof.NoneMoment')}}
    </div>
  </div>
</template>

<script>
import addIFile from '../../assets/images/workOrderReview/addIFile.png'
import {Toast} from 'mint-ui'
export default {
  name: 'FileUploader',
  props: ['callback', 'defaultFile', 'BankStatementName', 'disabled', 'bottomuse'],
  data () {
    return {
      addIFile,
      fileList: [] // 存储上传的文件列表
    }
  },
  watch: {
    callback (val) {
      if (val === -1) {
        this.fileList = []
      }
    },
    defaultFile (val) {}
  },
  mounted () {},
  methods: {
    removeFile () {
      this.fileList = []
      this.$emit('removeFile', null)
    },
    goFile () {
      window.open(this.defaultFile)
    },
    onFileChange (event) {
      const files = event.target.files
      if (files.length === 0) {
        return
      }

      // 检查文件类型是否为图片
      const isImageFile = Array.from(files).some(file => file.type.startsWith('image/'))
      if (isImageFile) {
        Toast(this.$t('lang.UploadProof.noUpImg'))
        this.$refs['fileInput'].value = ''
        this.removeFile()
        return // 防止上传图片文件
      }

      this.$emit('getFile', files[0])
      this.$emit('bottomuseGetFile', files[0])
      if (!this.bottomuse) {
        this.fileList = [files[0]]
      }
    },
    formatFileSize (size) {
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      let unitIndex = 0
      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex++
      }
      return `${size.toFixed(2)}${units[unitIndex]}`
    }
  }
}
</script>

<style lang="less" scoped>
.file-uploader {
  width: 100%;
  height: 100%;
  position: relative;
}

.file-uploader input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0; /* 隐藏实际的文件输入 */
  position: absolute;
  cursor: pointer;
}

.file-list {
  margin-top: 10px; /* 留出空间，避免与输入框重叠 */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .fileInfo{
    display: flex;
    flex-direction: column;
    align-items: center;
   position: relative;
    top: 4vw;
    font-size: 2.777vw;
    color: #fff;
   gap: 3vw;
    height: 100%;
    width: 100%;
    .closeBtn{
      height: 3.33vw;
      width: 3.33vw;
      position: absolute;
      right: 2vw;
      top: -5vw;
    }
    input{
      width: 100%;
      height: 100%;
      opacity: 0; /* 隐藏实际的文件输入 */
      position: absolute;
      cursor: pointer;
      //background-color: red;
      top: -6vw;
    }
    img{
      width: 6.852vw;
      height: 8.566vw;
    }
  }
}

.file-list ul {
  list-style-type: none;
  padding: 0;
}

.file-list li {
  margin: 5px 0;
}

.image-preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* 保持图片的宽高比 */
}
.uploadTip{
  color: #686868;
  font-size: 2.777vw;
  font-weight: 700;
  margin-top: 1vw;
}
.mask{
  position: absolute;
  height: 110%;
  width: 100%;
  background-color: rgba(0,0,0,.7);
  top: -3vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewDetails{
  color: #02A7F0;
  font-size: 3.194vw;
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrderReview/fileUpload.vue